<template>
  <v-container class="elevation-3 white px-5">
    <v-row>
      <v-col
        cols="12"
        class="h1 px-5 pt-5 pb-3"
      >
        <v-icon
          class="pr-3"
          style="margin-top: -4px"
          >fa-tasks</v-icon
        >
        {{ $i18n.t('home.works').toUpperCase() }}
      </v-col>
      <v-col cols="12">
        <div class="h-spacer-0" />
      </v-col>
      <v-col :class="$vuetify.breakpoint.lgAndUp ? 'home-work-orders' : ''">
        <v-container class="pa-0">
          <v-row no-gutters>
            <v-col
              v-for="(work, index) in works"
              :key="index"
              cols="12"
            >
              <v-container class="pa-0">
                <v-row
                  style="background: #f2f2f2"
                  dense
                  class="px-3"
                >
                  <v-col cols="5"> # {{ work.work_number }} </v-col>
                  <v-col
                    cols="7"
                    class="text-right"
                  >
                    {{ $i18n.t('works.mainDateShort') }}
                    <b>{{ formatDate(work.main_date) }}</b>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12">
                    <span class="h2">
                      {{ work.activity_park && work.activity_park.name }} </span
                    ><br />
                    {{
                      work.activity_park && work.activity_park.name_extension
                    }}
                  </v-col>
                  <v-col
                    v-if="
                      work.work_type && work.work_type[`name_${$i18n.locale}`]
                    "
                    cols="12"
                    class="py-0"
                  >
                    {{ work.work_type[`name_${$i18n.locale}`] }}
                  </v-col>
                  <v-col cols="12">{{ work.work_description || '-' }}</v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '@/store/state'
import worksQueries from '@/components/Works/worksQueries'
import helper from '@/helper'
import api from '@/store/api'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'HomeWorks',

  data() {
    return {
      loading: false,
      view: 'aligned',
      works: [],
    }
  },

  created() {
    this.loadAllWorks()
  },

  computed: {
    ...mapFields(Object.keys(state)),

    organizationFilterIds() {
      return this.$store.state.globalFilters.organization
        .map((i) => i.id)
        .join(' ')
    },
  },

  watch: {
    organizationFilterIds() {
      this.loadAllWorks()
    },
  },

  methods: {
    showOnMap() {
      this.activityParksDefaultFilters = JSON.parse(
        JSON.stringify(this.activityParksListDefaultOptions)
      )
      this.$set(
        this.activityParksFilters,
        'ids',
        this.selectedWorks
          .filter((work) => work.activity_park)
          .map((work) => work.activity_park.id)
      )
      this.$set(this.activityParksFilters, 'limit', 100)
      this.mapView = true
      this.$router.push({ path: '/parks' })
    },

    formatDate(date) {
      return helper.formatDate(date)
    },

    loadAllWorks() {
      this.loading = true
      const filters = {
        _inspection_work: false,
        order: 'main_date desc',
        offset: 0,
        limit: 5,
      }
      api.getWorksForHome(filters, worksQueries.forList).then((response) => {
        this.loading = false
        if (response && response.items) {
          this.works = response.items
        }
      })
    },
  },
}
</script>

<style>
.home-work-orders {
  min-height: 1400px;
  max-height: 1400px;
  overflow: auto;
}
</style>
